/**
 * printIssueTicketsApi — AISC §1.7.0 Phase 4 PIT client.
 */

import ApiCall from "./apicall";

export const PIT_STATUSES = ["REQUESTED", "PRINTED", "DELIVERED", "CANCELLED"];
export const PIT_DEPARTMENTS = ["PURCHASING", "SHOP", "SHIPPING", "OFFICE", "OPERATIONS", "OTHER"];

export async function listPits(filters = {}) {
  const params = {};
  if (filters.job_id) params.job_id = filters.job_id;
  if (filters.status) params.status = filters.status;
  if (filters.issued_to_department) params.issued_to_department = filters.issued_to_department;
  if (filters.limit) params.limit = filters.limit;
  const res = await ApiCall.get("/print-issue-ticket", { params });
  return res.data;
}
export async function getPit(id) { const res = await ApiCall.get(`/print-issue-ticket/${id}`); return res.data; }
export async function createPit(payload) { const res = await ApiCall.post("/print-issue-ticket", payload); return res.data; }
export async function printPit(id) { const res = await ApiCall.post(`/print-issue-ticket/${id}/print`); return res.data; }
export async function deliverPit(id) { const res = await ApiCall.post(`/print-issue-ticket/${id}/deliver`); return res.data; }
export async function cancelPit(id, cancellation_reason) { const res = await ApiCall.post(`/print-issue-ticket/${id}/cancel`, { cancellation_reason }); return res.data; }

export function allowedPitTransitions(status) {
  const T = { REQUESTED: ["PRINTED", "CANCELLED"], PRINTED: ["DELIVERED", "CANCELLED"], DELIVERED: [], CANCELLED: [] };
  return T[String(status || "").toUpperCase()] || [];
}
